//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';

import { QuoteSummaryBreakdown } from '@campaigns/components/campaign-requests/sampling-campaigns/shared/QuoteSummaryBreakdown';
import { useSamplingCampaign } from '@campaigns/hooks/useSamplingCampaign';
import { isDefined } from '@utils/filterPredicates';

export const SamplingCampaignRequestQuoteSummary = () => {
  const { samplingCampaignRequest } = useSamplingCampaign();

  if (!isDefined(samplingCampaignRequest)) {
    return null;
  }

  const {
    audienceDetails,
    bvClientId,
    fulfillmentOptions,
    memberTasks = {},
    products = [],
  } = samplingCampaignRequest;

  const totalUnits = products.reduce(
    (total, product) => total + (product.quantity ?? 0),
    0,
  );

  return (
    <QuoteSummaryBreakdown
      content={{
        units: totalUnits,
        writeReview: memberTasks.writeReview,
        postOnSocial: memberTasks.postOnSocial,
        postSurvey: memberTasks.postSurvey,
      }}
      fulfillment={{
        fulfillmentOptions,
        country: audienceDetails?.country,
        bvClientId,
      }}
    />
  );
};
